import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { HttpServiceAccount } from "../services/Authorization/http/http.service_Account";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { expandedSidebar } from "src/environments/environment";
import { OverlayPanel } from "primeng/overlaypanel";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.css"],
    providers: [HttpServiceAccount, MessageService],
})
export class SidebarComponent implements OnInit {
    navbar: ExtendedMenuItem[] = [];
    // Changed variable names to proper form
    isSidebarExpanded: boolean = expandedSidebar;
    isSidebarCollapsed: boolean = true;
    // Made a particular interface for MenuElement
    mainSidebarList: MenuElement[] = [];
    extraSidebarList: MenuElement[] = [];
    enteredPassword: string;
    correctPassword: string;
    routingLink: string;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    scrHeight: any;
    scrWidth: any;

    // Count of skeleton items can be adjusted by changing the number of elements in the array
    skeletonMenu: number[] = new Array(expandedSidebar ? 15 : 2).fill(0);
    showSkeleton: boolean = true;

    businessName: string = "";

    errorVisibleTimeout: ReturnType<typeof setTimeout>;

    @ViewChild("overlayPanel", { static: false }) overlayPanel: OverlayPanel;
    @ViewChild("passwordInput1", { static: false }) passwordInput1: ElementRef<HTMLInputElement>;
    @ViewChild("passwordInput2", { static: false }) passwordInput2: ElementRef<HTMLInputElement>;

    dialogVisible: boolean = false;

    constructor(
        private httpServiceAccount: HttpServiceAccount,
        private messageService: MessageService,
        private router: Router,
        private logger: NGXLogger
    ) {
        this.getScreenSize();
    }

    ngOnInit() {
        this.httpServiceAccount.getMainBar()
            // Added the MenuElement interface to the received data
            .subscribe((data: MenuElement[]) => {
                data = data.map((item: MenuElement) => ({ ...item, mb_router_link: "/" + item.mb_router_link }));

                this.mainSidebarList = data.filter((item: MenuElement) => item.mb_active > 0);
                this.extraSidebarList = data.filter((item: MenuElement) => item.mb_active == 0);

                this.showSkeleton = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.businessName = sessionStorage.getItem("businessName");
    }

    @HostListener("window:resize", ["$event"])
    getScreenSize(event?) {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
    }

    isTabbable(condition: boolean): number {
        return !condition ? 0 : -1;
    }

    toggleSidebar(): void {
        this.isSidebarCollapsed = !this.isSidebarCollapsed;
    }

    collapseSidebar(): void {
        this.isSidebarCollapsed = true;
    }

    openPopup(password: string, link: string, event: Event): void {
        this.correctPassword = password;
        this.routingLink = link;
        if (this.scrWidth > 991) {
            this.overlayPanel.toggle(event);
            setTimeout(() => {
                this.passwordInput1.nativeElement.focus();
            }, 0);
        } else {
            this.dialogVisible = true;
            setTimeout(() => {
                this.passwordInput2.nativeElement.focus();
            }, 50);
        }
    }

    onHideOverlay(): void {
        this.hideOverlay(this.overlayPanel, false);
        this.enteredPassword = "";
    }

    onHideDialog(): void {
        this.hideDialog(false);
        this.enteredPassword = "";
    }

    submitPassword(): void {
        if (this.scrWidth > 991) {
            this.hideOverlay(this.overlayPanel, true);
        } else {
            this.hideDialog(true);
        }
        if (this.enteredPassword === this.correctPassword) {
            this.router.navigate([this.routingLink]);
            this.isSidebarCollapsed = true;
            this.messageService.clear();
        }
    }

    hideOverlay(overlaypanel: OverlayPanel, isPasswordSubmited: boolean): void {
        overlaypanel.hide();
        if (this.enteredPassword !== this.correctPassword && isPasswordSubmited) {
            this.showMessage("error", "הודעת שגיאה סיסמה לא נכונה");
        }
    }

    hideDialog(isPasswordSubmited: boolean): void {
        this.dialogVisible = false;
        if (this.enteredPassword !== this.correctPassword && isPasswordSubmited) {
            this.showMessage("error", "הודעת שגיאה סיסמה לא נכונה");
        }
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }
}

interface MenuElement {
    icon: string;
    mb_active: number;
    mb_id: number;
    mb_is_enabled_role: number;
    mb_name: string;
    mb_order_id: number;
    mb_password_type: number;
    mb_router_link: string;
    password: string;
}